/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import actions from 'redux/actions';

import { getFindSmartlistParams, getSmartlists } from 'redux/reducers/smartlists';

import type { ReduxState, Fetchable, FindSmartlistParams, Smartlist } from 'types';
import type { ContextRouter } from 'react-router-dom';

import SliderList from 'components/SliderList';
import Sidebar from 'components/Sidebar';
import DataLoader from 'components/DataLoader';
import ScrollableContent from 'components/ScrollableContent';
import CoverCard from 'components/CoverCard';

import protonesUtils from 'utils/protones';

import styles from './styles.module.scss';

type Props = ContextRouter & {
  params: FindSmartlistParams,
  smartlists: Fetchable<Smartlist[]>,
  pageScroll: number,
  fetchSmartlists: typeof actions.fetchSmartlists,
  askSmartlist: typeof actions.askSmartlist,
  smartlistsSetPageScroll: typeof actions.smartlistsSetPageScroll,
};

type State = {
  playingSmartlistId: number | null,
};

const mapStateToProps = (state: ReduxState, ownProps: Props) => {
  return {
    params: getFindSmartlistParams(state),
    smartlists: getSmartlists(state),
    pageScroll: state.smartlists.pageScroll,
  };
};

class Smartlists extends React.Component<Props, State> {
  state = {
    playingSmartlistId: null,
  };

  scrollContainer: any = React.createRef();
  pageScroll: number = 0;

  componentDidMount() {
    if (!this.props.smartlists.data) {
      this.props.fetchSmartlists({});
    }
    if (this.scrollContainer.current) {
      this.scrollContainer.current.scrollTo(0, this.props.pageScroll);
    }
  }

  componentWillUnmount() {
    this.props.smartlistsSetPageScroll(this.pageScroll);
  }

  _handlePageScroll = (event: any) => {
    const element = event.target;
    const pageScroll = element.scrollTop;
    this.pageScroll = pageScroll;
  };

  _handleRefreshSmartlists = () => {
    this.props.fetchSmartlists({});
  };

  _handleSmartlistClick = (smartlist: Smartlist) => {
    protonesUtils.goTo(this.props, protonesUtils.routes.smartlists.get(smartlist.id));
  };

  _renderNoData = () => {
    return <div />;
  };

  _renderSmartlists = data => {
    if (!data || !data.length) {
      return this._renderNoData();
    }
    return (
      <SliderList
        items={data}
        render={item => (
          <CoverCard
            title={item.name}
            imgSrc={item.coverUrl}
            trackSrc={item.demoUrl}
            isPlaying={item.id === this.state.playingSmartlistId}
            onTogglePlay={() =>
              this.setState({
                playingSmartlistId: item.id === this.state.playingSmartlistId ? null : item.id,
              })
            }
            description={item.description}
            onClick={() => this._handleSmartlistClick(item)}
          />
        )}
        renderNoData={this._renderNoData}
        isExpanded={true}
      />
    );
  };

  _askSmartlist = () => {
    this.props.askSmartlist();
    protonesUtils.goTo(this.props, protonesUtils.routes.ondemand.find());
  };

  render() {
    const {
      smartlists: { data, fetching, error },
      t,
    } = this.props;
    return (
      <div className={styles.root}>
        <Sidebar
          title={t('SMARTLISTS')}
          onRefresh={this._handleRefreshSmartlists}
          loading={fetching}
          onAsk={this._askSmartlist}
        />
        <ScrollableContent ref={this.scrollContainer} onScroll={this._handlePageScroll}>
          <div className={styles.main}>
            <h2>{t('COMING_SOON')}</h2>
            <p>{t('TRY_SMARTLISTS')}</p>
            <br />
            <DataLoader
              loading={fetching}
              error={error}
              data={data}
              render={this._renderSmartlists}
            />
          </div>
        </ScrollableContent>
      </div>
    );
  }
}

export default withTranslation()(connect(mapStateToProps, actions)(Smartlists));
